import { DeleteOutlined, EditOutlined } from '@ant-design/icons'
import { Button, Form, Space, Tooltip } from 'antd'
import dayjs from 'dayjs'
import { debounce } from 'lodash'
import get from 'lodash.get'
import React, { useEffect, useState } from 'react'
import { hasPermission } from '../../config-func'
import { ACTION_MODE, PAGE_SIZE_OPTIONS } from '../../configData'
import {
  recruitmentDelete,
  recruitmentSearch,
  recruitmentUpdate
} from '../../services/management-recruitment-service'
import Card from '../Card'
import ModalCustom from '../common/Modal/ModalCustom'
import ModalConfirm, { showConfirm } from '../common/ModalConfirm/ModalConfirm'
import openNotification from '../common/Notification/openNotification '
import PhoneVisibilityCell from '../common/PhoneVisibilityCell'
import ExportButton from '../common/ExportButton'
import TableField from '../common/Table/TableField'
import FilterForm from './FilterForm'
import FormPost from './FormPost'
import Loading from '../Loading'
const ManagementRecruitment = () => {
  const permissions = JSON.parse(localStorage.getItem('permissions') || '[]')
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [mode, setMode] = useState(ACTION_MODE.VIEW)
  const [form] = Form.useForm()
  const [dataSource, setDataSource] = useState([])
  const [total, setTotal] = useState(0)
  const [loading, setLoading] = useState(false)
  const [detail, setDetail] = useState()
  // get arr select
  const [filters, setFilters] = useState({
    currentPage: 1,
    pageSize: 10
  })

  const handleSearch = debounce(() => {
    if (filters.currentPage === 1) {
      fetchData()
    } else {
      setFilters((prev) => ({ ...prev, currentPage: 1 }))
    }
  }, 500)

  async function fetchData() {
    setLoading(true)

    let _dataSource = []
    let _total = 0

    const params = {
      page: filters.currentPage,
      pageSize: filters.pageSize,
      full_name: filters.full_name,
      phone_number: filters.phone_number,
      position: filters.position,
      status: filters.status
      // post_status: filters.status || '',
    }

    const cleanedData = Object.fromEntries(
      Object.entries(params).filter(
        ([_, value]) => value !== '' && value !== null && value !== undefined
      )
    )

    try {
      const response = await recruitmentSearch(cleanedData)
      _dataSource = response?.data?.list
      _total = response?.data?.total
    } catch (error) {
      openNotification(
        'error',
        error?.response?.data?.message || 'Đã có lỗi xảy ra'
      )
    } finally {
      setLoading(false)
      setDataSource(_dataSource)
      setTotal(_total)
    }
  }

  useEffect(() => {
    fetchData()
  }, [filters.currentPage, filters.pageSize, filters.reset])
  // -=0-=0-====================================================================================================
  // Columns for Table
  const initialColumns = [
    {
      title: 'STT',
      dataIndex: 'stt',
      key: 'stt',
      fixed: 'left',
      width: 60,
      align: 'center',
      render: (_, __, index) =>
        (filters.currentPage - 1) * filters.pageSize + index + 1
    },
    {
      title: 'Mã tin tuyển dụng',
      dataIndex: 'id',
      key: 'id',
      width: 60
    },
    {
      title: 'Họ và tên',
      dataIndex: 'full_name',
      key: 'full_name',
      width: 150
    },
    {
      title: 'Số điện thoại',
      dataIndex: 'phone_number',
      key: 'phone_number',
      width: 170,
      render: (_, record) => (
        <PhoneVisibilityCell
          value={record?.phone_number}
          recruitmentId={record?.id}
          type="recruitment"
        />
      )
    },
    {
      title: 'Vị trí ứng tuyền',
      dataIndex: 'position',
      key: 'position',
      width: 150
      // render: (_, record) => <span>{record?.user_info?.name}</span>
    },
    {
      title: 'Lời nhắn',
      dataIndex: 'note',
      key: 'note',
      width: 150
    },
    {
      title: 'Trạng thái',
      dataIndex: 'status',
      key: 'status',
      width: 150,
      render: (_, record) => (
        <span>{record?.status == '0' ? 'Chưa xử lý' : 'Đã xử lý'}</span>
      )
    },
    {
      title: 'Thời gian gửi',
      dataIndex: 'created_at',
      key: 'created_at',
      width: 150,
      render: (value) => (value ? dayjs(value).format('DD/MM/YYYY') : '')
    },
    {
      title: 'Hành động',
      key: 'status',
      fixed: 'right',
      width: 150,
      render: (_, record) => {
        return (
          <Space size="small">
            {hasPermission('P78.2', permissions) && (
              <Tooltip title="Chỉnh sửa">
                <Button
                  style={{ width: 32 }}
                  icon={<EditOutlined />}
                  onClick={() => {
                    setMode(ACTION_MODE.UPDATE)
                    setDetail(record)
                    setIsModalOpen(true)
                    // getDetailProject(record.id)
                  }}
                />
              </Tooltip>
            )}
            {hasPermission('P78.3', permissions) && (
              <Tooltip title="Xóa">
                <Button
                  style={{ width: 32 }}
                  icon={<DeleteOutlined style={{ color: 'red' }} />}
                  onClick={() =>
                    showConfirm({
                      title: 'Xác nhận xoá',
                      content: (
                        <div>
                          Bạn có chắc chắn muốn xoá bản ghi
                          <b> {record.project_name}</b> không?
                        </div>
                      ),
                      onOk: () => handleDeleteProject(record.id)
                    })
                  }
                />
              </Tooltip>
            )}
          </Space>
        )
      }
    }
  ]

  // Thêm sửa project
  const handleSave = async () => {
    setLoading(true)
    try {
      // Validate các trường trong form
      const values = await form.validateFields()
      // Kiểm tra nếu cả hai giá trị đều tồn tại
      const { id, note1, ...data } = values
      const res = await recruitmentUpdate(
        {
          ...data,
          note: note1
        },
        id
      )

      // if(res?.message !== "Cập nhật thành công !")  return
      form.resetFields()
      setIsModalOpen(false)
      fetchData()
      setLoading(false)
      openNotification(
        'success',
        mode == ACTION_MODE.ADD ? '' : 'Cập nhật tuyển dụng thành công'
      )
    } catch (err) {
      setLoading(false)

      const errors = get(err, 'response.data.data', [])
      const errorMessages =
        errors?.map((error) => error.message).join('\n') ||
        get(err, 'response.data.message', [])
      openNotification('error', errorMessages || 'Đã có lỗi xảy ra')
    }
  }

  // Xóa project
  const handleDeleteProject = async (ids) => {
    setLoading(true)
    const body = {
      ids: [ids]
    }
    try {
      const res = await recruitmentDelete(ids, body || [])
      fetchData()
      openNotification('success', res.message)
      setLoading(false)
    } catch (err) {
      setLoading(false)
      console.error('Error creating product:', err)
      const errors = get(err, 'response.data.data', [])
      const errorMessages =
        errors?.map((error) => error.message).join('\n') ||
        get(err, 'response.data.message', [])
      openNotification('error', errorMessages || 'Đã có lỗi xảy ra')
    }
  }

  return (
    <div>
      <Loading loading={loading} />
      <Card className="mb-2">
        <FilterForm
          handleSearch={handleSearch}
          setFilters={setFilters}
          fetchData={fetchData}
        />
      </Card>

      <Card>
        <div
          style={{
            display: 'flex',
            justifyContent: 'flex-end',
            alignItems: 'center',
            margin: '0px 50px 10px 0px',
            width: '100%'
          }}
        >
          <div style={{ marginLeft: 'auto', display: 'flex', gap: '8px' }}>
            <ExportButton
              columns={initialColumns}
              data={dataSource}
              fileName="Quan_ly_tuyen_dung"
              sheetName="Tuyển dụng"
              permission="P78.1"
            />
          </div>
        </div>
        <TableField
          loading={loading}
          columns={initialColumns}
          dataSource={dataSource}
          scroll={{ x: 'max-content', y: 'calc(100vh - 400px)' }}
          className={`custom-table`}
          // locale={{
          //   emptyText: <Empty description="Không có dữ liệu" />, // Hiển thị "Không có dữ liệu" khi bảng không có dữ liệu
          //   triggerDesc: 'Sắp xếp giảm dần', // Khi click vào cột để sort giảm dần
          //   triggerAsc: 'Sắp xếp tăng dần', // Khi click vào cột để sort tăng dần
          //   cancelSort: 'Hủy sắp xếp' // Khi bỏ sắp xếp
          // }}

          // columns={
          //   filters.isDefault === 'fixed'
          //     ? columns.filter(
          //         (item) => !['calculationMethod'].includes(item.dataIndex)
          //       )
          //     : columns.filter(
          //         (item) => !['isDefault'].includes(item.dataIndex)
          //       )
          // }

          pagination={{
            current: filters.currentPage,
            pageSize: filters.pageSize,
            total: total,
            pageSizeOptions: PAGE_SIZE_OPTIONS,
            showSizeChanger: true,
            onShowSizeChange: (current, size) => {
              setFilters((prev) => ({
                ...prev,
                pageSize: size,
                currentPage: 1
              }))
            },
            onChange: (page) => {
              setFilters((prev) => ({ ...prev, currentPage: page }))
            },
            showTotal: (total, range) =>
              `Hiển thị ${range[0]}-${range[1]} của ${total} bản ghi`,
            locale: { items_per_page: 'bản ghi / trang' }
          }}
          rowKey={(record, index) => index}
          locale={{ emptyText: 'Không có dữ liệu' }}
        />
      </Card>
      {/* Modal Thêm mới sản phẩm */}
      <ModalCustom
        title={'Chỉnh sửa tuyển dụng'}
        visible={isModalOpen}
        centered
        onCancel={() => {
          setIsModalOpen(false)
          form.resetFields()
        }}
        width={800}
        onConfirm={async () => {
          try {
            await form.validateFields() // Kiểm tra validation trước khi tiếp tục
            handleSave() // Nếu hợp lệ thì tiếp tục xử lý
          } catch (error) {
            console.log('Validation failed:', error)
          }
        }}
        confirmText={'Lưu'}
        cancelText="Đóng"
      >
        <FormPost
          form={form}
          handleSearch={handleSearch}
          data={detail}
          handleSave={handleSave}
        />
      </ModalCustom>
      <ModalConfirm />
    </div>
  )
}

export default ManagementRecruitment
